import { useEffect, useState } from 'react';

export function usePulseAnimation(
  trigger: number,
  duration: number = 1000
): boolean {
  const [isPulsing, setIsPulsing] = useState(false);

  useEffect(() => {
    if (trigger === 0) {
      return;
    }

    // Force animation restart by removing class first
    setIsPulsing(false);

    // Use double RAF to ensure browser processes the state change before re-applying
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setIsPulsing(true);
      });
    });

    // Clear pulsing state after animation completes
    const timer = setTimeout(() => {
      setIsPulsing(false);
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [trigger, duration]);

  return isPulsing;
}
